import { render, staticRenderFns } from "./comp-5.vue?vue&type=template&id=e67f27da&scoped=true"
import script from "./comp-5.vue?vue&type=script&lang=js"
export * from "./comp-5.vue?vue&type=script&lang=js"
import style0 from "./comp-5.vue?vue&type=style&index=0&id=e67f27da&prod&lang=less&scoped=true"
import style1 from "./comp-5.vue?vue&type=style&index=1&id=e67f27da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67f27da",
  null
  
)

export default component.exports